import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';

export interface Action{
  icon: JSX.Element;
  name: string;
  fabProps?: object;
  onClick?(): void;
}



export default function PLSpeedDial({actions}:{actions?: Action[]}) {
  return (
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: 'absolute', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
        direction="left"
      >
        {actions && actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
            FabProps={action.fabProps}
            
          />
        ))}

        
      </SpeedDial>
  );
}